<script>
    import { onMount } from "svelte";
    import * as api from "../utiles/api";
    import { push } from "svelte-spa-router";
    import Btm from "../components/Btm.svelte";
    import * as common from "../utiles/common.util";

    let pageSize = 10; // 한 번에 로드할 데이터 개수
    let currentPage = 0; // 현재 페이지
    let currentList = [];
    let dataList = [];

    onMount(() => {
        getData();
    });

    async function getData() {
        currentPage = 0;
        currentList = [];

        const response = await api.get(
            `/partner?keyword=&page=1&sort=${decodeURI(
                "a.created_at DESC"
            )}&cate=&usePageNavy=false`
        );

        if (response != null) {
            dataList = [];
            dataList = response.data;
            loadMore(); // 초기 데이터 로드
        }
    }

    function loadMore() {
        const start = currentPage * pageSize;
        const end = start + pageSize;

        currentList = [...currentList, ...dataList.slice(start, end)];
        currentPage++;
    }

    function handleScroll(event) {
        const { scrollTop, scrollHeight, clientHeight } = event.target;

        if (scrollTop + clientHeight >= scrollHeight - 10) {
            if (currentList.length < dataList.length) {
                loadMore();
            }
        }
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-missing-attribute -->
<div class="main-body custom-partner-list">
    <div class="main-content">
        <header class="list-header">
            <h1>협력 업체 관리</h1>
            <div class="list-count">총 {dataList.length}개 업체</div>
        </header>

        <div class="as-list-container scroll-custom" on:scroll={handleScroll}>
            {#if currentList && currentList.length > 0}
                {#each currentList as data, index}
                    <div
                        class="as-card-item"
                        on:click={() => {
                            push(`/PartnerDetail/${data.cmpn_id}`);
                        }}
                    >
                        <div class="as-card-header">
                            <span class="as-label-sm">NO.{index + 1}</span>
                            <span class="as-partner-name">{data.name}</span>
                            <span class="as-badge">상세보기</span>
                        </div>

                        <div class="as-card-body">
                            <div class="as-info-row">
                                <span class="as-label">대표자</span>
                                <span class="as-value">{data.owner || "-"}</span>
                            </div>

                            <div class="as-info-row">
                                <span class="as-label">연락처</span>
                                <a href="tel:{data.tel}" class="as-value as-tel" on:click|stopPropagation>
                                    {common.formatPhoneNumber(data.tel)}
                                </a>
                            </div>

                            <div class="as-info-row">
                                <span class="as-label">주소</span>
                                <span class="as-value as-address">
                                    {(data.addr1 || "" + " " + (data.addr2 || "")).trim() || "-"}
                                </span>
                            </div>

                            <div class="as-info-row">
                                <span class="as-label">사업자번호</span>
                                <span class="as-value">{common.formatBusinessNumber(data.bizno)}</span>
                            </div>
                        </div>
                    </div>
                {/each}
            {:else}
                <div class="as-none-data">
                    <p>등록된 협력 업체가 없습니다.</p>
                </div>
            {/if}
        </div>

        <Btm />
    </div>
</div>

<style>
    .custom-partner-list.main-body {
        background-color: var(--bg-primary) !important;
        min-height: 100vh;
    }
    .custom-partner-list .main-content {
        max-width: 1024px;
        margin: 0 auto;
        height: 100vh;
        display: flex;
        flex-direction: column;
        background-color: var(--bg-primary);
    }

    /* Header */
    .custom-partner-list .list-header {
        background-color: var(--bg-secondary);
        padding: 20px 16px;
        border-bottom: 1px solid var(--border-color);
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: sticky;
        top: 0;
        z-index: 100;
    }
    .custom-partner-list h1 {
        font-size: 18px;
        font-weight: 800;
        color: var(--text-primary);
        margin: 0;
    }
    .custom-partner-list .list-count {
        font-size: 13px;
        color: var(--text-tertiary);
        font-weight: 600;
    }

    /* List Container */
    .custom-partner-list .as-list-container {
        flex: 1;
        overflow-y: auto;
        padding: 16px;
        padding-bottom: 100px;
    }

    /* Partner Card */
    .custom-partner-list .as-card-item {
        background-color: var(--bg-secondary);
        border-radius: 12px;
        box-shadow: var(--shadow-sm);
        margin-bottom: 16px;
        overflow: hidden;
        border: 1px solid var(--border-color);
        transition: transform 0.2s, box-shadow 0.2s;
        cursor: pointer;
    }
    .custom-partner-list .as-card-item:active {
        transform: scale(0.98);
    }

    .custom-partner-list .as-card-header {
        padding: 12px 16px;
        background-color: var(--bg-tertiary);
        display: flex;
        align-items: center;
        border-bottom: 1px solid var(--border-color);
    }
    .custom-partner-list .as-label-sm {
        font-size: 11px;
        font-weight: 700;
        color: var(--text-tertiary);
        margin-right: 10px;
    }
    .custom-partner-list .as-partner-name {
        font-size: 15px;
        font-weight: 700;
        color: var(--text-primary);
        flex: 1;
    }
    .custom-partner-list .as-badge {
        font-size: 11px;
        font-weight: 700;
        color: var(--color-primary);
        background-color: var(--color-primary-light);
        padding: 3px 8px;
        border-radius: 4px;
    }

    .custom-partner-list .as-card-body {
        padding: 14px 16px;
    }
    .custom-partner-list .as-info-row {
        display: flex;
        margin-bottom: 6px;
        font-size: 14px;
        align-items: flex-start;
    }
    .custom-partner-list .as-label {
        width: 90px;
        color: var(--text-tertiary);
        font-weight: 500;
        font-size: 13px;
        flex-shrink: 0;
    }
    .custom-partner-list .as-value {
        flex: 1;
        color: var(--text-primary);
        word-break: break-all;
    }
    .custom-partner-list .as-tel {
        color: var(--color-primary);
        text-decoration: underline;
        font-weight: 600;
    }
    .custom-partner-list .as-address {
        line-height: 1.4;
    }

    .custom-partner-list .as-none-data {
        text-align: center;
        padding: 60px 20px;
        color: var(--text-tertiary);
    }
</style>
